import { SafetyNetEligibleTransferCtrl } from './safety-net-eligible-transfer.controller';

export const SafetyNetEligibleTransfer = {
  controller: SafetyNetEligibleTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./safety-net-eligible-transfer.html'),
};
